import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.typed-array.with.js";
// import test_data from '../../utils/test.json'
var test_data;
var renderer, scene, camera, controls, testData, geometry, geometryInner, directionalLight, pointLight, pointLight1, pointLight2, pointLight3;
export default {
  name: 'taoci',
  data() {
    return {
      data: {}
    };
  },
  methods: {
    test() {
      scene = new THREE.Scene(); //创建一个场景
      geometry = new THREE.BufferGeometry(); //创建一个空对象
      geometryInner = new THREE.BufferGeometry();
      this.setOutMesh();
      this.setInnerMesh();
      this.setLight();
      var width = window.innerWidth;
      var height = window.innerHeight;
      camera = new THREE.PerspectiveCamera(35, width / height, 1, 1000);
      camera.position.set(250, 250, 250);
      // camera.lookAt(scene.position);
      renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true
      });
      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.setSize(width, height);
      renderer.setClearAlpha(0.0);
      document.getElementById('taociWarp').appendChild(renderer.domElement);
      this.render();
      //使用鼠标转动视角
      controls = new THREE.TrackballControls(camera, renderer.domElement);
      controls.minDistance = 200;
      controls.maxDistance = 2000;
    },
    setOutMesh() {
      // 外部模型
      let verticesData = [];
      console.log(test_data, 'test_data');
      test_data.outerTriangles.map((item, index) => {
        let target = test_data.outerVertices[item];
        verticesData.push(target.x, target.y, target.z);
      });
      var vertices = new Float32Array(verticesData);

      // normal数据
      let normalsData = [];
      test_data.outerTriangles.map((item, index) => {
        let target = test_data.outerNormals[item];
        normalsData.push(target.x, target.y, target.z);
      });
      var normals = new Float32Array(normalsData);

      // 颜色
      // 内部颜色
      let colorsData = [];
      test_data.outerTriangles.map((item, index) => {
        let target = test_data.outerUvs[item];
        colorsData.push(target.x, target.y);
      });
      let colors = new Float32Array(colorsData);
      geometry.attributes.normal = new THREE.BufferAttribute(normals, 3);
      geometry.attributes.uv = new THREE.BufferAttribute(colors, 2);
      geometry.attributes.position = new THREE.Float32BufferAttribute(vertices, 3);
      geometry.computeBoundingSphere();

      // 材质
      // 贴图
      var texture = new THREE.TextureLoader().load(this.data.tietu);
      // var texture2 = new THREE.TextureLoader().load( 'http://192.168.20.80:8080/test/tietu2.jpg' );
      // var texture3 = new THREE.TextureLoader().load( 'http://192.168.20.80:8080/test/tietu3.png' );
      var meshMaterial = new THREE.MeshPhongMaterial({
        map: texture,
        // bumpMap: texture2,
        // bumpScale: 0.8,
        // metalnessMap: texture3,
        side: THREE.DoubleSide
      });
      console.log(meshMaterial);
      geometry.center();
      var mesh = new THREE.Mesh(geometry, meshMaterial); //创建一个网格
      mesh.scale.set(200, 200, 200);
      scene.add(mesh);
    },
    setLight() {
      // // 点光源
      pointLight = new THREE.PointLight(0xffffff, 0.1);
      pointLight.position.set(-300, 0, -100);
      scene.add(pointLight);
      pointLight1 = new THREE.PointLight(0xffffff, 0.1);
      pointLight1.position.set(100, 0, 300);
      scene.add(pointLight1);
      pointLight2 = new THREE.PointLight(0xffffff, 0.1);
      pointLight2.position.set(300, 0, -300);
      scene.add(pointLight2);
      pointLight3 = new THREE.PointLight(0xffffff, 0.1);
      pointLight3.position.set(0, -300, 0);
      // 半球光
      var ambientLight = new THREE.AmbientLight(0xffffff, 0.1);
      scene.add(ambientLight);
      var hemiLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 0.5);
      hemiLight.position.set(0, 500, 0);
      scene.add(hemiLight);
      directionalLight = new THREE.DirectionalLight(0xffffff, 0.5);
      directionalLight.position.set(0, 0, 250);
      scene.add(directionalLight);
    },
    setInnerMesh() {
      // 内部模型
      let verticesDataInner = [];
      test_data.innerTriangles.map(item => {
        let target = test_data.innerVertices[item];
        verticesDataInner.push(target.x, target.y, target.z);
      });
      var verticesInner = new Float32Array(verticesDataInner);
      // 内部颜色
      let colorsDataInner = [];
      test_data.innerTriangles.map((item, index) => {
        let target = test_data.innerUvs[item];
        colorsDataInner.push(target.x, target.y);
      });
      let colorsInner = new Float32Array(colorsDataInner);
      // 内部normal
      let normalsData = [];
      test_data.innerTriangles.map((item, index) => {
        let target = test_data.innerNormals[item];
        normalsData.push(target.x, target.y, target.z);
      });
      var normals = new Float32Array(normalsData);
      // 内部模型
      geometryInner.attributes.normal = new THREE.BufferAttribute(normals, 3);
      geometryInner.attributes.uv = new THREE.BufferAttribute(colorsInner, 2);
      geometryInner.attributes.position = new THREE.Float32BufferAttribute(verticesInner, 3);
      geometryInner.computeBoundingSphere();
      geometryInner.center();
      var materialInner = new THREE.MeshPhongMaterial({
        color: 0xffffff,
        side: THREE.DoubleSide
      });
      // 内部模型
      var meshInner = new THREE.Mesh(geometryInner, materialInner); //创建一个网格
      meshInner.scale.set(200, 200, 200);
      scene.add(meshInner); //将网格添加到场景中
    },
    render() {
      var vector = camera.position.clone();
      directionalLight.position.set(vector.x, vector.y, vector.z);
      pointLight.position.set(vector.x, vector.y, vector.z);
      pointLight1.position.set(vector.x, vector.y, vector.z);
      pointLight2.position.set(vector.x, vector.y, vector.z);
      pointLight3.position.set(vector.x, vector.y, vector.z);
      renderer.render(scene, camera);
    },
    animate() {
      requestAnimationFrame(this.animate);
      if (controls) {
        controls.update();
        this.render();
      } else {
        cancelAnimationFrame(this.animate);
      }
    },
    getData() {
      this.$api.getFormDetail(this.$route.query.fid, this.$route.query.formUserId, '58814333207261f71adc65231de60f2baa5084d3028db91d73d6a5f2391a6610').then(res => {
        // console.log(res)
        if (!res.formUserList || !res.formUserList.length) return;
        this.data.name = this.getValInFormData(res.formUserList[0].formData, 'name');
        this.data.tietu = this.getValInFormData(res.formUserList[0].formData, "texture", 'img');
        let dataUrl = this.getValInFormData(res.formUserList[0].formData, "data", 'file');
        console.log(this.data);
        this.$api.getUrlByObjectId(dataUrl).then(res => {
          // dataUrl = res.download.replace('http://d0.ananas.chaoxing.com/', 'https://museum.chaoxing.com/') 
          dataUrl = `http://192.168.20.80:8080/test/${res.filename}`;
          this.$ajax(dataUrl).then(res => {
            test_data = res.data;
            setTimeout(() => {
              this.test();
              this.animate();
            }, 1000);
          });
        });
      });
    },
    getValInFormData(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      });
      if (!target) return '';
      target = target.values[0];
      if (!target) return '';
      target.file = process.env.NODE_ENV != 'development' ? `https://museum.chaoxing.com/star3/origin/${target.objectId}.${target.suffix}` : `http://192.168.20.80:8080/test/${target.name}`;
      return type == 'img' ? target.file : type == 'file' ? target.objectId : target.val;
    }
  },
  created() {
    let list = ['FBXLoader.js', 'inflate.min.js', 'TGALoader.js', 'TrackballControls.js', 'PDBLoader.js', 'CSS2DRenderer.js', 'OBJLoader.js', 'FBXLoader.js', 'MTLLoader.js', 'Detector.js'];
    list.map(item => {
      let oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = `js/3d/${item}`;
      document.body.appendChild(oScript);
    });
    let list2 = ['jquery-1.11.0.min.js', 'heartcode-canvasloader-min.js'];
    list2.map(item => {
      let oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = `js/360/${item}`;
      document.body.appendChild(oScript);
    });
  },
  mounted() {
    this.getData();
  },
  computed: {}
};